export const saveUserData = (token, user, user_role, userData) => {
  localStorage.setItem('token', token)
  localStorage.setItem('user', user)
  localStorage.setItem('user_role', user_role)
  localStorage.setItem('userData', JSON.stringify(userData))
}

export const getUserData = () => {
  const token = localStorage.getItem('token')
  const user = localStorage.getItem('user')
  const user_role = localStorage.getItem('user_role')
  const userData = localStorage.getItem('userData')
  return {
    token,
    user: JSON.parse(user),
    user_role,
    userData: JSON.parse(userData),
  }
}

export const removeUserData = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  localStorage.removeItem('user_role')
  localStorage.removeItem('userData')
}
